<style scoped>
.ceshilb{width: 100%;}
.table1 {border-collapse: collapse;width: 100%;background: #F5F5F5;color: #606266;text-align: center;font-weight: 600;}
.table2{border-collapse: collapse;width: 100%;}
tr, td {border: 1px solid #f5eeee;padding: 5px;}
.tr .td {float: left;}
.tr {width: 100%;height: 50px;}
.first{width: 80px;}
.second{width: 50px;}
.third{width: 200px;}
.fourth{width: 400px;}
.fifth{width: 80px;}
.photo{width: 120px;}
.time{width: 160px;}
</style>

<template>
  <div class="ceshilb">
    <table class="table1">
      <tr>
      <td class="first">模块</td>
      <td class="second">排序</td>
      <td class="photo">图片</td>
      <td class="third">标题</td>
      <td class="fourth">简介</td>
      <td class="time">添加时间</td>
      <td class="fifth">操作</td>
      </tr>
    </table>
    <vuedraggable class="wrapper" v-model="tableData">
      <transition-group>
        <div v-for="(item, index) in tableData" :key="index" class="item">
          <table class="table2">
            <tr>
              <td class="first">{{item.moduleName}}</td>
              <td class="second">{{index+1}}</td>
              <td class="photo"><img :src='item.thumb' alt="" style="width:100px;height:85px"></td>
              <td class="third">{{item.title}}</td>
              <td class="fourth">{{item.introduce}}</td>
              <td class="time">{{item.addtime * 1000 | formatTime()}}</td>
              <td class="fifth"><el-button type="danger">删除</el-button></td>
            </tr>
          </table>
        </div>
      </transition-group>
    </vuedraggable>
  </div>
</template>

<script>
import vuedraggable from 'vuedraggable'
import filters from '../method/filter'
export default {
  components: {vuedraggable},
  mixins: [filters],
  props: {
  },
  data()
  {
    return {
      tableData: []
    }
  },
  updated()
  {
    this.tableData.forEach((data, index) =>
    {
    })
  },
  created()
  {
    this.getList()
  },
  methods: {
    getList()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 74, _exp: 'id > 0'}
      window.post.getPost(paras).then((ret) =>
      {
        this.tableData = []
        ret.forEach((data, index) =>
        {
          this.tableData.push({ title: '', thumb: '', introduce: '', moduleName: '', addtime: data.addtime })
          let paras = {cmd: 'query', _major: 99, _minor: 4, _exp: `major = ${data.major} and minor = ${data.minor}`}
          window.post.getPost(paras).then((rets) =>
          {
            this.tableData[index].moduleName = rets[0].namec
          })
          let paras1 = {cmd: 'query', _major: data.major, _minor: data.minor, _exp: `id = ${data.newsid}`}
          window.post.getPost(paras1).then((retss) =>
          {
            this.tableData[index].title = retss[0].title
            this.tableData[index].thumb = retss[0].thumb
            this.tableData[index].introduce = retss[0].introduce
          })
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/assembly/CeshiLB.vue